import React from 'react';

export function CustomButton({label, onClick, className}) {
    return <button className={`${className}`}
            onClick={onClick}>
            {label}
           </button>
}

export default CustomButton;